(function () {
  const setExpanded = (item, expanded) => {
    const button = item.querySelector(".collapsible-content__toggle");
    const answer = item.querySelector(".collapsible-content__answer");

    if (!button || !answer) return;

    item.classList.toggle("active", expanded);
    button.setAttribute("aria-expanded", String(expanded));
    answer.hidden = !expanded;
    answer.style.display = expanded ? "block" : "none";
  };

  const initCollapsibleContent = (root = document) => {
    root.querySelectorAll(".collapsible-content__items").forEach((group, groupIndex) => {
      const items = Array.from(group.querySelectorAll(":scope > .collapsible-content__item"));

      items.forEach((item, itemIndex) => {
        if (item.dataset.collapsibleInitialised === "true") return;

        const button = item.querySelector(".collapsible-content__toggle");
        const answer = item.querySelector(".collapsible-content__answer");

        if (!button || !answer) return;

        const idBase = `collapsible-${groupIndex}-${itemIndex}`;
        button.type = "button";
        button.id = button.id || `${idBase}-button`;
        answer.id = answer.id || `${idBase}-answer`;
        button.setAttribute("aria-controls", answer.id);
        answer.setAttribute("role", "region");
        answer.setAttribute("aria-labelledby", button.id);

        setExpanded(item, item.classList.contains("active"));

        button.addEventListener("click", () => {
          const shouldOpen = !item.classList.contains("active");

          items.forEach((sibling) => {
            if (sibling !== item) setExpanded(sibling, false);
          });

          setExpanded(item, shouldOpen);
        });

        item.dataset.collapsibleInitialised = "true";
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initCollapsibleContent(), { once: true });
  } else {
    initCollapsibleContent();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initCollapsibleContent(event.target);
  });
})();